module.exports = {
    //baseUrl: 'https://customerapi.livefacetof.com', // 正式项目地址
    //wsurl: 'wss://customerapi.livefacetof.com/staff',
    baseUrl: 'https://fifa-imapi.jinkunzs.com',
    wsurl: 'wss://fifa-imapi.jinkunzs.com/staff',
}